export default {"src":"__ASTRO_ASSET_IMAGE__$Vj6eJyN__","width":246,"height":86,"format":"svg"}